import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'vp-availability-group-booking-notice',
	templateUrl: './availability-group-booking-notice.html',
	imports: [TranslatePipe],
	host: { class: 'block w-0 min-w-full' },
})
export class AvailabilityGroupBookingNoticeComponent {
	contactUrl = input.required<string>();
}
